import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'
import bus from '@/views/eventBus'

const apiClient = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

let authExpiredNotified = false

export function getAuthHeaders() {
  const token = window.sessionStorage.getItem('token')
  return token ? { Authorization: 'Bearer ' + token } : {}
}

function showLoginExpired() {
  window.sessionStorage.removeItem('token')
  window.sessionStorage.removeItem('userID')
  if (!authExpiredNotified) {
    authExpiredNotified = true
    Message.error('Login expired, please sign in again')
    setTimeout(() => {
      authExpiredNotified = false
    }, 1500)
  }
  if (/^\/(user|userinfo|mymusic)/.test(router.currentRoute.path)) {
    router.replace('/').catch(() => {})
  }
  bus.$emit('show', true)
}

apiClient.interceptors.request.use(config => {
  config.headers = config.headers || {}
  const token = window.sessionStorage.getItem('token')
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  } else {
    delete config.headers.Authorization
  }
  return config
})

apiClient.interceptors.response.use(
  response => {
    const res = response.data
    if (res && res.code === 401) {
      showLoginExpired()
      return Promise.reject(new Error(res.message || 'login_required'))
    }
    return response
  },
  error => {
    if (error.response && error.response.status === 401) {
      showLoginExpired()
    }
    return Promise.reject(error)
  }
)

export default apiClient
